module.exports = __webpack_public_path__ + "Roboto-Medium.cf4d60bc0b1d4b231408.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/node_modules/materialize-css/dist/fonts/roboto/Roboto-Medium.woff
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Medium.woff
// module chunks = styles